export default "__VITE_ASSET__C4y8KCT1__"